var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../../libs/keybindings');
var session = require('../../auth/models/session');
var edit = require('../../layout/components/edit');
var loaders = require('../../layout/components/loaders');

var searchEquipmentOverall = {};

var suppressEditShortcut = function () {
  key.unbind('e');
  key.unbind('e', 'all');
  key.unbind('e', 'home');
};

var restoreEditShortcut = function () {
  key.unbind('e', 'all');
  key.unbind('e', 'home');
  key('e', function () {
    if (session.user().isSuperuser == 1) {
      edit.vm.toggle();
      m.redraw();
    }
  });
};

var requestCounter = 0; // Global counter to track requests

function buildEntitySearchBaseUrl(selectedClasses) {
  var params = new URLSearchParams();
  if (Array.isArray(selectedClasses) && selectedClasses.length) {
    params.set('classes', selectedClasses.join(','));
  } else {
    params.set('families', 'Equipment,Room,Building,Level,Zone');
  }
  return `/api/v1/entities/search?${params.toString()}`;
}

function buildSelectionKey(values) {
  if (!Array.isArray(values)) return '';
  return values.slice().sort().join('|');
}

var focusInputIfActive = function (ctrl, attrs, dom) {
  if (!attrs) { return; }
  var isActiveStream = attrs.searchEquipmentActive;
  var isActive = typeof isActiveStream === 'function' ? isActiveStream() : false;
  if (!isActive) {
    ctrl.lastActiveState = false;
    return;
  }
  var token = attrs.focusToken;
  var shouldFocus = false;
  if (token != null && token !== ctrl.lastFocusToken) {
    ctrl.lastFocusToken = token;
    shouldFocus = true;
  }
  if (!shouldFocus && !ctrl.lastActiveState && isActive) {
    shouldFocus = true;
  }
  ctrl.lastActiveState = isActive;
  if (!shouldFocus) {
    return;
  }
  var attempt = function () {
    if (dom && typeof dom.focus === 'function') {
      dom.focus();
      if (typeof dom.select === 'function') {
        dom.select();
      }
    }
  };
  requestAnimationFrame(function () {
    attempt();
    setTimeout(attempt, 25);
  });
};

searchEquipmentOverall.oninit = function (vnode) {
  var ctrl = this;
  ctrl.location = vnode.attrs.location();
  ctrl.preferredNumberOfRowsValue = vnode.attrs.preferredNumberOfRowsValue();
  ctrl.equipmentClassesSelected = prop(vnode.attrs.equipmentClassesSelected());
  ctrl.equipmentSelectionKey = buildSelectionKey(ctrl.equipmentClassesSelected());
  ctrl.lastFocusToken = -1;
  ctrl.lastActiveState = false;
  ctrl.debounceTimer = null;
  ctrl.activeState = typeof vnode.attrs.searchEquipmentActive === 'function'
    ? !!vnode.attrs.searchEquipmentActive()
    : false;

  ctrl.init = function () {
    vnode.attrs.equipmentTableLoading(true);
    const currentRequestId = ++requestCounter;
    ctrl.latestRequestId = currentRequestId;
    vnode.attrs.searchedEquipmentRids([]);
    vnode.attrs.equipmentToShow([]);
    const baseUrl = buildEntitySearchBaseUrl(ctrl.equipmentClassesSelected());
    const locationRid = vnode.attrs.location()['@rid'];

    const ridPromise = loaders.requestWithLoader({
      url: baseUrl,
      params: {
        search: vnode.attrs.searchEquipmentValue(),
        onlyDirectEquipment: 0,
        locationRid: locationRid,
        mode: 'rids'
      },
      method: 'GET',
      background: true
    })
    .then(data => {
      if (ctrl.latestRequestId === currentRequestId) {
        vnode.attrs.searchedEquipmentRids(data);
      }
    });

    const paginatedPromise = loaders.requestWithLoader({
      url: baseUrl,
      params: {
        pageNumber: 0,
        search: vnode.attrs.searchEquipmentValue(),
        preferredNumberOfRowsValue: vnode.attrs.preferredNumberOfRowsValue(),
        locationRid: locationRid,
        mode: 'paginated'
      },
      method: 'GET',
      background: true
    })
    .then(data => {
      if (ctrl.latestRequestId === currentRequestId) {
        data.forEach(r => {
          if (r['$path'] && Array.isArray(r['$path'])) {
            if (!r['$path'][r['$path'].length - 1].name) {
              r['$path'][r['$path'].length - 1].name = r['$path'][r['$path'].length - 1]['@class'];
            }
          }
        })
        vnode.attrs.equipmentToShow(data);
      }
    });

    Promise.all([
      ridPromise.catch(() => null),
      paginatedPromise.catch(() => null)
    ])
    .finally(() => {
      if (ctrl.latestRequestId === currentRequestId) {
        vnode.attrs.equipmentTableLoading(false);
        m.redraw();
      }
    })
  }

  if (ctrl.activeState) {
    ctrl.init();
  }
}

searchEquipmentOverall.onupdate = function(vnode) {
  var ctrl = this;
  var nextSelectionKey = buildSelectionKey(vnode.attrs.equipmentClassesSelected());
  var nextActiveState = typeof vnode.attrs.searchEquipmentActive === 'function'
    ? !!vnode.attrs.searchEquipmentActive()
    : false;
  if (
    ctrl.activeState !== nextActiveState ||
    ctrl.location['@rid'] != vnode.attrs.location()['@rid'] || 
    ctrl.preferredNumberOfRowsValue != vnode.attrs.preferredNumberOfRowsValue() ||
    ctrl.equipmentSelectionKey !== nextSelectionKey
  ) {
    ctrl.location = vnode.attrs.location();
    ctrl.preferredNumberOfRowsValue = vnode.attrs.preferredNumberOfRowsValue();
    ctrl.equipmentClassesSelected(vnode.attrs.equipmentClassesSelected());
    ctrl.equipmentSelectionKey = nextSelectionKey;
    ctrl.activeState = nextActiveState;
    if (ctrl.activeState) {
      ctrl.init();
    }
  }
}

searchEquipmentOverall.view = function(vnode) {
  var ctrl = this;
  return m('div', [
    m(`span.ba.b--blue.br2.ph1.flex.items-center.mr2.h2`, {
      id: 'searchEquipmentSpan',
      class: vnode.attrs.searchEquipmentActive() ? 'searchEquipmentSpanBig' : 'searchEquipmentSpanSmall',
      onclick: (e) => {
        vnode.attrs.searchEquipmentActive(true);
      }
    },[
      m('div.nowrap', {style: {display: (vnode.attrs.searchEquipmentActive() ? 'none' : 'block')}}, [
        m('i', {
          class: 'blue f2 mh3 ion-search pointer',
        })
      ]),
      m('div.flex.items-center', {style: {display: (vnode.attrs.searchEquipmentActive() ? 'flex' : 'none')}}, [
        m('input.mh1.mv1.w4', {
          id: 'equipment-paginated-table-search-input',
          placeholder: 'Search equipment or rooms',
          value: vnode.attrs.searchEquipmentValue(),
          oncreate: function (inputVnode) {
            focusInputIfActive(ctrl, vnode.attrs, inputVnode.dom);
          },
          onupdate: function (inputVnode) {
            focusInputIfActive(ctrl, vnode.attrs, inputVnode.dom);
          },
          oninput: function (ev) { 
            vnode.attrs.searchEquipmentValue(ev.target.value);
            if (ctrl.debounceTimer) {
              clearTimeout(ctrl.debounceTimer);
            }
            ctrl.debounceTimer = setTimeout(function () {
              ctrl.init();
            }, 750);
          },
          onblur: (e) => {
            if (vnode.attrs.searchEquipmentValue().length == 0) {
              vnode.attrs.searchEquipmentActive(false);
            }
            restoreEditShortcut();
          },
          onfocusin: (e) => {
            suppressEditShortcut();
          },
          onkeydown: function (e) {
            var typedKey = e && e.key ? e.key.toLowerCase() : '';
            if (typedKey === 'e' && !e.ctrlKey && !e.metaKey && !e.altKey) {
              e.stopPropagation();
            }
          }
        }),
        vnode.attrs.searchEquipmentValue() && vnode.attrs.searchEquipmentValue().length > 0 ? 
          m('i', {
            class: 'blue f4 mr1 ion-close-circled pointer',
            onclick: (e) => {
              vnode.attrs.searchEquipmentValue('');
              vnode.attrs.searchEquipmentActive(false);
              if (ctrl.debounceTimer) {
                clearTimeout(ctrl.debounceTimer);
                ctrl.debounceTimer = null;
              }
              ctrl.init();
            }
          })
        :
          ''
      ])
    ])
  ])
}

searchEquipmentOverall.onremove = function () {
  if (this.debounceTimer) {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = null;
  }
  restoreEditShortcut();
};

module.exports = searchEquipmentOverall;
